<script lang="ts">
	import Layout from "@components/layout/Layout.svelte";
	import { getTranslate } from "@utils/translate.js";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import translations from "./Gdpr.translations.json" with { type: "json" };
	import type { GdprProps } from "./GdprProps.js";

	const _: GdprProps = $props();

	const { WEB_URL } = getGlobalSettings();
	const translate = getTranslate(translations);
	const { tenant } = getGlobalTemplateProps();
</script>

<Layout>
	<div class="lg:w-[50rem]">
		<h1 class="m-0 mb-4 p-0 font-normal lg:mb-7 lg:leading-[3.25rem]">
			{translate("headline")}
		</h1>
	</div>

	<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
		<h2
			id="poskytnuti-udaju"
			class="mb-0 scroll-mt-28 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7"
		>
			{translate("consentDataTitle")}
		</h2>
	</div>
	<div class="lg:w-[50rem]">
		<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("consentData")}</p>
	</div>

	<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
		<h2
			id="multimedialni-obsah"
			class="mb-0 scroll-mt-28 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7"
		>
			{translate("consentMediaTitle")}
		</h2>
	</div>
	<div class="lg:w-[50rem]">
		<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("consentMedia")}</p>
	</div>

	<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
		<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
			{translate("gatheredDataTitle")}
		</h2>
	</div>
	<div class="lg:w-[50rem]">
		<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
			{translate("gatheredData1")} <a href={WEB_URL}>{WEB_URL.replace(/https?[:][/][/]/u, "")}</a>
			{translate("gatheredData2")}
		</p>
	</div>
	<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
		<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
			{translate("dataTransferTitle")}
		</h2>
	</div>
	<div class="lg:w-[50rem]">
		<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("dataTransfer1")}</p>
		<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("dataTransfer2")}</p>
		<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
			{translate("dataTransfer3")} <a href="mailto:{translate('email')}">{translate("email")}</a>
			{translate("dataTransfer4")}
		</p>
	</div>

	<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
		<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
			{translate("thirdPartyTitle")}
		</h2>
	</div>
	<div class="lg:w-[50rem]">
		<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("thirdParty")}</p>
	</div>

	<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
		<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
			{translate("googleAnalyticsTitle")}
		</h2>
	</div>
	<div class="lg:w-[50rem]">
		<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
			{translate("googleAnalytics1")}
		</p>
		<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
			{translate("googleAnalytics2")}
		</p>
		<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
			{translate("googleAnalytics3")}
			<a href="http://www.google.com/intl/{tenant.locale}/privacy/privacy-policy.html" target="_blank">
				policies.google.com/privacy
			</a>.
		</p>
	</div>

	<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
		<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
			{translate("cookiesTitle")}
		</h2>
	</div>
	<div class="lg:w-[50rem]">
		<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("cookies")}</p>
	</div>

	<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
		<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
			{translate("changesTitle")}
		</h2>
	</div>
	<div class="lg:w-[50rem]">
		<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("changes")}</p>
	</div>

	<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
		<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
			{translate("behaviorTitle")}
		</h2>
	</div>
	<div class="lg:w-[50rem]">
		<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("behavior")}</p>
	</div>

	<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
		<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
			{translate("liabilityTitle")}
		</h2>
	</div>
	<div class="lg:w-[50rem]">
		<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("liability")}</p>
	</div>
</Layout>
